import {Component} from '@angular/core';
import {StepComponent} from "../step/step.component";
import {StepService} from "../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../services/element.service";
import {PortalService} from "../services/portal.service";

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
  selector: 'app-verbrauchsanalyse-ausstieg',
  templateUrl: './verbrauchsanalyse.ausstieg.component.html'
})
export class VerbrauchsanalyseAusstiegComponent extends StepComponent {

  /**
   * The last step were we should navigate with the back button to.
   */
  lastStep: string = "../../einstieg";

  /**
   * define the case why we stop here.
   */
  case: string = null;

  /**
   * the anfrage object with the input of the user
   */
  anfrage: any;

  /**
   *
   * @param stepService
   * @param router
   * @param elementService
   * @param portalService
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService, protected portalService: PortalService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // check if there is a last step given were we should navigate in case of the backstep to
    if(history?.state?.lastStep) {
      this.lastStep = history.state.lastStep;
    }

    // check which case we should show
    if(this.anfrage.verbrauchsanalyseInput.hasOwnProperty("nutzungstyp") && this.anfrage.verbrauchsanalyseInput["nutzungstyp"] === "mieter") {
      // living for rent
      this.case = 'mieter';
    }
    else if(this.anfrage.verbrauchsanalyseInput.hasOwnProperty("gebaeude_denkmalschutz") && this.anfrage.verbrauchsanalyseInput["gebaeude_denkmalschutz"] === "ja") {
      // denkmalschutz
      this.case = 'denkmalschutz';
    }
    else if(this.anfrage.verbrauchsanalyseInput.hasOwnProperty("heizungstyp") && this.anfrage.verbrauchsanalyseInput["heizungstyp"] !== "zentral") {
      // decentralized heating
      this.case = 'dezentral';
      if (this.anfrage.verbrauchsanalyseInput.hasOwnProperty("nutzungstyp") && this.anfrage.verbrauchsanalyseInput["nutzungstyp"] === "wohnungseigentuemer") {
        this.case = 'dezentral.wohnungseigentuemer';
      }
    }
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector("body");
    this.elementService.scrollToElement(element)
  }
}
